export const GET_CONSENT = 'loans/GET_CONSENT'
export const GIVE_CONSENT = 'loans/GIVE_CONSENT'
export const GET_TOKEN = 'loans/GET_TOKEN'
